import { createColumnHelper } from "@tanstack/react-table";
import { qtyDisplay } from "@icraftx/shared/v1";
import type { DeskTableFeatures } from "@/modules/shell/data-table";

export type ProductBalanceRow = {
  warehouseCode: string;
  qty: string;
};

const balHelper = createColumnHelper<DeskTableFeatures, ProductBalanceRow>();

export function productBalanceColumns() {
  return balHelper.columns([
    balHelper.accessor("warehouseCode", {
      id: "warehouseCode",
      header: "Warehouse",
      size: 140,
      cell: (info) => (
        <span className="font-mono text-sm">{info.getValue()}</span>
      ),
    }),
    balHelper.accessor("qty", {
      id: "qty",
      header: "On hand",
      size: 100,
      cell: (info) => (
        <span className="font-mono tabular-nums">
          {qtyDisplay(info.getValue())}
        </span>
      ),
    }),
  ]);
}
